<template>
  <div class="email-results-wrap">
    <main class="screen" role="main">

      <span class="badge">Quiz abgeschlossen</span>

      <div class="intro">
        <h1 class="intro-title">Möchtest du dein Ergebnis per E-Mail erhalten?</h1>
        <p class="intro-text">
          Trage deine E-Mail-Adresse ein und wähle, was wir dir senden dürfen.
        </p>
      </div>

      <div class="form-row">
        <label for="email">E-Mail-Adresse</label>
        <input
          type="email"
          id="email"
          placeholder="dein.name@beispiel.ch"
          autocomplete="email"
          inputmode="email"
          v-model="email"
        >
      </div>

      <label class="option-card" for="opt-result">
        <div class="option-header">
          <input
            type="checkbox"
            id="opt-result"
            class="option-checkbox"
            v-model="optResult"
          >
          <div class="option-content">
            <p class="option-title">Ergebnis per E-Mail senden</p>
            <p class="option-description">
              Du erhältst dein Resultat als E-Mail. Danach wird deine Adresse
              sofort gelöscht.
            </p>
            <span class="privacy-tag no-store">✓ Adresse wird nicht gespeichert</span>
          </div>
        </div>
      </label>

      <label class="option-card" for="opt-reminder">
        <div class="option-header">
          <input
            type="checkbox"
            id="opt-reminder"
            class="option-checkbox"
            v-model="optReminder"
          >
          <div class="option-content">
            <p class="option-title">In 3 Monaten an Wiederholung erinnern</p>
            <p class="option-description">
              Wir senden dir eine einzige Erinnerung, damit du sehen kannst, wie
              sich dein Ergebnis entwickelt hat.
            </p>
            <span class="privacy-tag stores">Adresse wird bis zur Erinnerung gespeichert</span>
          </div>
        </div>
      </label>

      <div class="footer">
        <button
          type="button"
          class="submit-button"
          :disabled="!canSubmit"
          @click="submit"
        >Bestätigen</button>
        <button
          type="button"
          class="skip-button"
          @click="skip"
        >Nein danke, fertig</button>
      </div>

    </main>
  </div>
</template>

<script>
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'EmailOptInResults',
  data() {
    return {
      email: '',
      optResult: false,
      optReminder: false,
    };
  },
  computed: {
    isValidEmail() {
      return EMAIL_RE.test(this.email.trim());
    },
    canSubmit() {
      return this.isValidEmail && (this.optResult || this.optReminder);
    },
  },
  methods: {
    submit() {
      if (!this.canSubmit) return;
      this.$router.push('/postsurvey/thanks');
    },
    skip() {
      this.$router.push('/postsurvey/thanks');
    },
  },
};
</script>

<style scoped>
.email-results-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --color-good: #639922;
  --color-good-light: #EAF3DE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.email-results-wrap *,
.email-results-wrap *::before,
.email-results-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
}

.badge {
  display: inline-block;
  background: var(--color-accent-light);
  color: var(--color-accent);
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: var(--radius-md);
  margin-bottom: 1rem;
  letter-spacing: 0.02em;
}

.intro {
  margin-bottom: 1.5rem;
}

.intro-title {
  font-size: 22px;
  font-weight: 500;
  margin: 0 0 8px;
  line-height: 1.3;
}

.intro-text {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.6;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 1.5rem;
}

.form-row label {
  font-size: 13px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.form-row input[type="email"] {
  width: 100%;
  padding: 14px 16px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 16px;
  font-family: inherit;
  background: var(--color-bg-card);
  color: var(--color-text-primary);
}

.form-row input[type="email"]:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px var(--color-accent-light);
}

.option-card {
  display: block;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  margin-bottom: 12px;
  background: var(--color-bg-card);
  transition: background 0.15s, border-color 0.15s;
  cursor: pointer;
}

.option-card:has(input:checked) {
  background: var(--color-accent-light);
  border-color: var(--color-accent);
}

.option-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.option-checkbox {
  margin: 2px 0 0 0;
  width: 18px;
  height: 18px;
  accent-color: var(--color-accent);
  flex-shrink: 0;
}

.option-content { flex: 1; }

.option-title {
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 4px;
  color: var(--color-text-primary);
  line-height: 1.3;
}

.option-description {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0 0 8px;
  line-height: 1.5;
}

.privacy-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.privacy-tag.no-store {
  background: var(--color-good-light);
  color: var(--color-good);
}

.privacy-tag.stores {
  background: var(--color-bg-muted);
  color: var(--color-text-secondary);
}

.footer {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.submit-button {
  width: 100%;
  padding: 14px;
  background: var(--color-bg-muted);
  color: var(--color-text-tertiary);
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  cursor: not-allowed;
}

.submit-button:not(:disabled) {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
  cursor: pointer;
}

.submit-button:not(:disabled):hover {
  opacity: 0.9;
}

.skip-button {
  width: 100%;
  padding: 14px;
  background: transparent;
  color: var(--color-text-secondary);
  border: none;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.skip-button:hover {
  color: var(--color-text-primary);
}
</style>
